import { CartModulePaymentInitRequestModel } from "../model/Cart/CartModulePaymentInitRequestModel";
import { CartViewModel } from "../model/Cart/CartViewModel";
import { PaymentTransactionViewModel } from "../model/Cart/PaymentTransactionViewModel";
import { ApiResponse, customFetch } from "./CustomFetch";

export const getCart = (checkExamAvailability: boolean = true): Promise<CartViewModel> => {
  return customFetch(`Cart?checkExamAvailability=${checkExamAvailability}`)
    .then((response) => response.json() as Promise<ApiResponse<CartViewModel>>)
    .then((apiResponse) => apiResponse.data);
};

export const setCart = (cart: CartViewModel): Promise<CartViewModel> => {
  return customFetch("Cart", {
    body: JSON.stringify(cart),
    headers: { "Content-Type": "application/json" },
    method: "POST",
  })
    .then((response) => response.json() as Promise<ApiResponse<CartViewModel>>)
    .then((apiResponse) => apiResponse.data);
};

export const checkTransactionStatus = (transactionId: string): Promise<PaymentTransactionViewModel> => {
  return customFetch(`Cart/checkTransactionStatus/${transactionId}`)
    .then((response) => response.json() as Promise<ApiResponse<PaymentTransactionViewModel>>)
    .then((apiResponse) => apiResponse.data);
};

export const initModulePayment = (
  paymentInfo: CartModulePaymentInitRequestModel
): Promise<ApiResponse<PaymentTransactionViewModel>> => {
  return customFetch("Cart/initModulePayment", {
    body: JSON.stringify(paymentInfo),
    headers: { "Content-Type": "application/json" },
    method: "POST",
  }).then((response) => response.json() as Promise<ApiResponse<PaymentTransactionViewModel>>);
};

export const clearCart = (): Promise<void> => {
  return customFetch("Cart/clear", {
    body: "",
    headers: { "Content-Type": "application/json" },
    method: "POST",
  }).then((response) => response.json() as Promise<void>);
};
